import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Composant icône œil pour masquer/afficher un module pour le client
 *
 * @param {boolean} isVisible - Le module est-il visible pour le client
 * @param {function} onToggle - Callback appelé avec moduleId lors du clic
 * @param {string} userRole - Rôle de l'utilisateur (ADMIN, USER, CLIENT)
 * @param {string} moduleId - Identifiant du module
 * @param {string} title - Titre du tooltip (optionnel)
 */
const ModuleVisibilityToggle = ({ isVisible, onToggle, userRole, moduleId, title }) => {
  // Les clients ne voient pas l'icône
  if (userRole === 'CLIENT') {
    return null;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (typeof onToggle === 'function') {
      onToggle(moduleId);
    }
  };

  const tooltipText = title || (isVisible
    ? 'Masquer ce module pour le client'
    : 'Afficher ce module pour le client');

  return (
    <button
      onClick={handleClick}
      className={`module-visibility-toggle ${!isVisible ? 'is-hidden' : ''}`}
      title={tooltipText}
      aria-label={tooltipText}
    >
      {isVisible ? <Eye size={16} /> : <EyeOff size={16} />}
    </button>
  );
};

export default ModuleVisibilityToggle;
